/**
 * UI metadata for sport event types (keyed by event_type_code from API).
 * Aligns with apinew AbstractTeamService::resolveLiveblogEventIdAdditional / updateMatchFromEvent.
 */

export const EVENT_TYPE_META = {
    KO: {
        shortLabel: 'Kick off',
        icon: 'mdi-whistle',
        category: 'match',
        requiresPlayer: false,
        requiresRelatedPlayer: false,
        requiresTeam: true,
        showScoreboard: false,
        quickOrder: 10,
    },
    HT: {
        shortLabel: 'Half time',
        icon: 'mdi-timer-outline',
        category: 'match',
        requiresPlayer: false,
        requiresRelatedPlayer: false,
        requiresTeam: false,
        showScoreboard: false,
        quickOrder: 11,
    },
    SHS: {
        shortLabel: '2nd half',
        icon: 'mdi-timer-play-outline',
        category: 'match',
        requiresPlayer: false,
        requiresRelatedPlayer: false,
        requiresTeam: false,
        showScoreboard: false,
        quickOrder: 12,
    },
    FT: {
        shortLabel: 'Full time',
        icon: 'mdi-flag-checkered',
        category: 'match',
        requiresPlayer: false,
        requiresRelatedPlayer: false,
        requiresTeam: false,
        showScoreboard: false,
        quickOrder: 13,
    },
    SHE: {
        shortLabel: '2nd half end',
        icon: 'mdi-timer-off-outline',
        category: 'match',
        requiresPlayer: false,
        requiresRelatedPlayer: false,
        requiresTeam: false,
        showScoreboard: false,
        quickOrder: 14,
    },
    GL: {
        shortLabel: 'Goal',
        icon: 'mdi-soccer',
        category: 'scoring',
        requiresPlayer: true,
        requiresRelatedPlayer: false,
        requiresTeam: true,
        showScoreboard: true,
        quickOrder: 1,
    },
    PM: {
        shortLabel: 'Missed pen',
        icon: 'mdi-soccer-field',
        category: 'scoring',
        requiresPlayer: true,
        requiresRelatedPlayer: false,
        requiresTeam: true,
        showScoreboard: false,
        quickOrder: 6,
    },
    VAR_GD: {
        shortLabel: 'VAR',
        icon: 'mdi-television',
        category: 'var',
        requiresPlayer: false,
        requiresRelatedPlayer: false,
        requiresTeam: true,
        showScoreboard: true,
        quickOrder: 7,
    },
    YC: {
        shortLabel: 'Yellow',
        icon: 'mdi-card text-warning',
        category: 'discipline',
        requiresPlayer: true,
        requiresRelatedPlayer: false,
        requiresTeam: true,
        showScoreboard: false,
        quickOrder: 2,
    },
    RC: {
        shortLabel: 'Red',
        icon: 'mdi-card text-danger',
        category: 'discipline',
        requiresPlayer: true,
        requiresRelatedPlayer: false,
        requiresTeam: true,
        showScoreboard: false,
        quickOrder: 3,
    },
    Y2C: {
        shortLabel: '2nd yellow',
        icon: 'mdi-cards text-danger',
        category: 'discipline',
        requiresPlayer: true,
        requiresRelatedPlayer: false,
        requiresTeam: true,
        showScoreboard: false,
        quickOrder: 4,
    },
    GC: {
        shortLabel: 'Green card',
        icon: 'mdi-card text-success',
        category: 'discipline',
        requiresPlayer: true,
        requiresRelatedPlayer: false,
        requiresTeam: true,
        showScoreboard: false,
        quickOrder: 5,
    },
    SUB: {
        shortLabel: 'Sub',
        icon: 'mdi-swap-horizontal',
        category: 'lineup',
        requiresPlayer: true,
        requiresRelatedPlayer: true,
        requiresTeam: true,
        showScoreboard: false,
        quickOrder: 8,
    },
    ET1H: {
        shortLabel: 'ET 1st half',
        icon: 'mdi-timer-plus-outline',
        category: 'extra_time',
        requiresPlayer: false,
        requiresRelatedPlayer: false,
        requiresTeam: false,
        showScoreboard: false,
        quickOrder: 20,
    },
    ET1HE: {
        shortLabel: 'ET 1st end',
        icon: 'mdi-timer-outline',
        category: 'extra_time',
        requiresPlayer: false,
        requiresRelatedPlayer: false,
        requiresTeam: false,
        showScoreboard: false,
        quickOrder: 21,
    },
    ET2H: {
        shortLabel: 'ET 2nd half',
        icon: 'mdi-timer-plus-outline',
        category: 'extra_time',
        requiresPlayer: false,
        requiresRelatedPlayer: false,
        requiresTeam: false,
        showScoreboard: false,
        quickOrder: 22,
    },
    ET2HE: {
        shortLabel: 'ET 2nd end',
        icon: 'mdi-timer-outline',
        category: 'extra_time',
        requiresPlayer: false,
        requiresRelatedPlayer: false,
        requiresTeam: false,
        showScoreboard: false,
        quickOrder: 23,
    },
    PS: {
        shortLabel: 'Penalties',
        icon: 'mdi-target',
        category: 'penalties',
        requiresPlayer: false,
        requiresRelatedPlayer: false,
        requiresTeam: false,
        showScoreboard: false,
        quickOrder: 24,
    },
    SHO: {
        shortLabel: 'Shootout',
        icon: 'mdi-hockey-puck',
        category: 'other',
        requiresPlayer: true,
        requiresRelatedPlayer: false,
        requiresTeam: true,
        showScoreboard: false,
        quickOrder: 30,
    },
    SHOM: {
        shortLabel: 'Shootout miss',
        icon: 'mdi-close-circle-outline',
        category: 'other',
        requiresPlayer: true,
        requiresRelatedPlayer: false,
        requiresTeam: true,
        showScoreboard: false,
        quickOrder: 31,
    },
    LB: {
        shortLabel: 'Liveblog',
        icon: 'mdi-pencil',
        category: 'other',
        requiresPlayer: false,
        requiresRelatedPlayer: false,
        requiresTeam: false,
        showScoreboard: false,
        quickOrder: 99,
    },
    P: {
        shortLabel: 'Pause',
        icon: 'mdi-pause',
        category: 'basketball',
        requiresPlayer: false,
        requiresRelatedPlayer: false,
        requiresTeam: false,
        showScoreboard: false,
        quickOrder: 40,
    },
    '1QS': { shortLabel: 'Q1 start', icon: 'mdi-numeric-1-circle', category: 'basketball', requiresPlayer: false, requiresRelatedPlayer: false, requiresTeam: false, showScoreboard: false, quickOrder: 41 },
    '1QE': { shortLabel: 'Q1 end', icon: 'mdi-numeric-1-circle-outline', category: 'basketball', requiresPlayer: false, requiresRelatedPlayer: false, requiresTeam: false, showScoreboard: false, quickOrder: 42 },
    '2QS': { shortLabel: 'Q2 start', icon: 'mdi-numeric-2-circle', category: 'basketball', requiresPlayer: false, requiresRelatedPlayer: false, requiresTeam: false, showScoreboard: false, quickOrder: 43 },
    '2QE': { shortLabel: 'Q2 end', icon: 'mdi-numeric-2-circle-outline', category: 'basketball', requiresPlayer: false, requiresRelatedPlayer: false, requiresTeam: false, showScoreboard: false, quickOrder: 44 },
    '3QS': { shortLabel: 'Q3 start', icon: 'mdi-numeric-3-circle', category: 'basketball', requiresPlayer: false, requiresRelatedPlayer: false, requiresTeam: false, showScoreboard: false, quickOrder: 45 },
    '3QE': { shortLabel: 'Q3 end', icon: 'mdi-numeric-3-circle-outline', category: 'basketball', requiresPlayer: false, requiresRelatedPlayer: false, requiresTeam: false, showScoreboard: false, quickOrder: 46 },
    '4QS': { shortLabel: 'Q4 start', icon: 'mdi-numeric-4-circle', category: 'basketball', requiresPlayer: false, requiresRelatedPlayer: false, requiresTeam: false, showScoreboard: false, quickOrder: 47 },
    '4QE': { shortLabel: 'Q4 end', icon: 'mdi-numeric-4-circle-outline', category: 'basketball', requiresPlayer: false, requiresRelatedPlayer: false, requiresTeam: false, showScoreboard: false, quickOrder: 48 },
}

/** Full words for timeline / reader-facing labels (shortLabel stays compact for quick buttons). */
const EVENT_DISPLAY_LABELS = {
    KO: 'Kick off',
    HT: 'Half Time',
    SHS: 'Start Second Half',
    FT: 'Full Time',
    SHE: 'Second Half End',
    GL: 'Goal',
    PM: 'Missed penalty',
    VAR_GD: 'VAR - Goal Disallowed',
    YC: 'Yellow Card',
    RC: 'Red Card',
    Y2C: 'Second Yellow - Red Card',
    GC: 'Green Card',
    SUB: 'Substitution',
    ET1H: 'Extra time - first half Start',
    ET1HE: 'Extra time - first half End',
    ET2H: 'Extra time - second half Start',
    ET2HE: 'Extra time - second half End',
    PS: 'Penalty shootout Start',
    SHO: 'Shootout',
    SHOM: 'Shootout Miss',
    LB: 'Liveblog',
    P: 'Pause',
    '1QS': 'First Quarter Start',
    '1QE': 'First Quarter End',
    '2QS': 'Second Quarter Start',
    '2QE': 'Second Quarter End',
    '3QS': 'Third Quarter Start',
    '3QE': 'Third Quarter End',
    '4QS': 'Fourth Quarter Start',
    '4QE': 'Fourth Quarter End',
}

const DEFAULT_META = {
    shortLabel: 'Event',
    icon: 'mdi-circle-small',
    category: 'other',
    requiresPlayer: false,
    requiresRelatedPlayer: false,
    requiresTeam: false,
    showScoreboard: false,
    quickOrder: 100,
}

/** Quick-access codes for football live entry (only shown if tenant has them). */
export const FOOTBALL_QUICK_EVENT_CODES = [
    'GL',
    'YC',
    'RC',
    'Y2C',
    'SUB',
    'PM',
    'VAR_GD',
    'KO',
    'HT',
    'SHS',
    'SHE',
    'FT',
    'ET1H',
    'ET1HE',
    'ET2H',
    'ET2HE',
    'PS',
]

export const EXTRA_QUICK_EVENT_CODES = ['GC', 'SHO', 'SHOM', 'LB', 'P', '1QS', '1QE', '2QS', '2QE', '3QS', '3QE', '4QS', '4QE']

export function normalizeEventTypeCode(code) {
    return code ? String(code).trim().toUpperCase() : ''
}

export function getEventTypeMeta(code) {
    const key = normalizeEventTypeCode(code)
    const base = EVENT_TYPE_META[key] || { ...DEFAULT_META, shortLabel: key || DEFAULT_META.shortLabel }
    return {
        ...base,
        displayLabel: EVENT_DISPLAY_LABELS[key] || base.shortLabel || DEFAULT_META.shortLabel,
    }
}

export function findEventTypeByCode(eventTypes, code) {
    if (!Array.isArray(eventTypes) || !code) return null
    const target = normalizeEventTypeCode(code)
    return (
        eventTypes.find((et) => normalizeEventTypeCode(et.event_type_code) === target) ||
        null
    )
}

export function resolveEventMetaFromItem(item, eventTypes = []) {
    if (!item) return { ...DEFAULT_META }
    if (item.event_type_code) {
        return getEventTypeMeta(item.event_type_code)
    }
    const match = eventTypes.find(
        (et) => String(et.event_type_id) === String(item.event_type_id)
    )
    if (match && match.event_type_code) {
        return getEventTypeMeta(match.event_type_code)
    }
    return getEventTypeMetaFromName(item.event_type_name)
}

function getEventTypeMetaFromName(name) {
    if (!name) return { ...DEFAULT_META }
    const lower = String(name).toLowerCase()
    if (lower.includes('goal') && !lower.includes('disallow')) {
        return getEventTypeMeta('GL')
    }
    if (lower.includes('subst')) return getEventTypeMeta('SUB')
    if (lower.includes('yellow') && lower.includes('red')) return getEventTypeMeta('Y2C')
    if (lower.includes('yellow')) return getEventTypeMeta('YC')
    if (lower.includes('red')) return getEventTypeMeta('RC')
    if (lower.includes('var')) return getEventTypeMeta('VAR_GD')
    if (lower.includes('penalt') && lower.includes('miss')) return getEventTypeMeta('PM')
    if (lower === 'start' || lower.includes('kick')) return getEventTypeMeta('KO')
    if (lower.includes('half') && lower.includes('time') && !lower.includes('second')) {
        return getEventTypeMeta('HT')
    }
    if (lower.includes('second half') && lower.includes('start')) return getEventTypeMeta('SHS')
    if (lower.includes('second half') && lower.includes('end')) return getEventTypeMeta('SHE')
    if (lower === 'end' || lower.includes('full time')) return getEventTypeMeta('FT')
    return { ...DEFAULT_META, shortLabel: name }
}

export function buildQuickEventButtons(eventTypes, codes = FOOTBALL_QUICK_EVENT_CODES) {
    if (!Array.isArray(eventTypes)) return []
    return codes
        .map((code) => {
            const et = findEventTypeByCode(eventTypes, code)
            if (!et) return null
            const meta = getEventTypeMeta(et.event_type_code)
            return {
                code,
                label: meta.shortLabel,
                eventTypeId: String(et.event_type_id),
                icon: meta.icon,
                category: meta.category,
                order: meta.quickOrder,
            }
        })
        .filter(Boolean)
        .sort((a, b) => a.order - b.order)
}

export function resolveEventMetaForForm(eventTypes, eventTypeId) {
    if (!eventTypeId || !Array.isArray(eventTypes)) return { ...DEFAULT_META }
    const match = eventTypes.find((et) => String(et.event_type_id) === String(eventTypeId))
    if (!match) return { ...DEFAULT_META }
    return getEventTypeMeta(match.event_type_code)
}

function normalizeEventDisplayName(name, item) {
    let label = String(name || '').trim()
    if (!label) return ''
    if (/^half\s+t\s*ime$/i.test(label)) return 'Half Time'
    if (label === 'End' && String(item?.event_type_id) === '4') return 'Full Time'
    if (label === 'Start' && String(item?.event_type_id) === '1') return 'Kick off'
    return label
}

/** Full event name for timeline (not abbreviated quick-button labels). */
export function resolveEventDisplayName(item, eventTypes = []) {
    if (!item) return 'Event'
    const fromItem = normalizeEventDisplayName(item.event_type_name, item)
    if (fromItem) return fromItem

    const match = Array.isArray(eventTypes)
        ? eventTypes.find((et) => String(et.event_type_id) === String(item.event_type_id))
        : null
    const fromCatalog = normalizeEventDisplayName(match?.event_type_name, item)
    if (fromCatalog) return fromCatalog

    const meta = resolveEventMetaFromItem(item, eventTypes)
    return meta.displayLabel || meta.shortLabel || 'Event'
}

/**
 * Human-readable timeline labels for sport events (editor-facing, not raw API fields).
 */
export function buildEventTimelineLabels(item, eventTypes = []) {
    const meta = resolveEventMetaFromItem(item, eventTypes)
    const eventLabel = resolveEventDisplayName(item, eventTypes)
    const result = {
        headline: eventLabel,
        subline: '',
        showScore: Boolean(meta.showScoreboard),
    }

    const hasPlayer = Boolean(item.player_name)
    const playerEvent = hasPlayer && (meta.requiresPlayer || meta.requiresRelatedPlayer || item.player_id)

    if (playerEvent) {
        result.headline = item.player_name
        const sub = [eventLabel]
        if (item.team_code) sub.push(item.team_code)
        if (item.related_player_name) sub.push(`↔ ${item.related_player_name}`)
        if (item.event_reason_name) sub.push(item.event_reason_name)
        result.subline = sub.join(' · ')
        return result
    }

    const sub = []
    if (item.team_code && meta.requiresTeam) sub.push(item.team_code)
    if (item.event_reason_name) sub.push(item.event_reason_name)
    result.subline = sub.join(' · ')
    return result
}
